import React, { Component } from 'react';
import dropin from 'braintree-web-drop-in';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component

class Dropin extends Component {
  static propTypes = {
    clientToken: PropTypes.string,
    form: PropTypes.shape.isRequired,
    onPaymentMethodReceived: PropTypes.func,
  };
  static defaultProps = {
    clientToken: '',
    onPaymentMethodReceived: () => {},
  };
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }
  componentWillMount() {
    const form = this.props.form;
    const onPaymentMethodReceived = this.props.onPaymentMethodReceived;
    dropin.create({
      authorization: this.props.clientToken,
      container: '#dropin-container',
      paypal: {
        flow: 'vault',
      },
    }, (err, dropinInstance) => { // eslint-disable-line
      if (err) {
            // Handle any errors that might've occurred when creating Drop-in
        return;
      }
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        dropinInstance.requestPaymentMethod((requestPaymentMethodError, payload) => {
          if (requestPaymentMethodError) {
                    // Handle errors in requesting payment method
            return;
          }
                // Send payload.nonce to your server
                /* nonceInput.value = payload.nonce; */
          onPaymentMethodReceived(payload);
        });
      });
    });
  }
  render() {
    return (
      <div id="dropin-container" />
    );
  }
}

export default Dropin;



// WEBPACK FOOTER //
// ./src/components/PaymentDropin/Dropin.js